import { createUseStyles } from 'react-jss';

import styling from '../../../services/styling';

export default createUseStyles(
  {
    title: {
      position: 'relative',
      textAlign: 'center',
      marginBottom: 110,
      zIndex: 1,
      [styling.breakpoints.up('md')]: {
        marginBottom: 160,
      },
      '&:after': {
        content: '""',
        opacity: 0.5,
        position: 'absolute',
        width: 2,
        left: '50%',
        top: '100%',
        backgroundColor: styling.colors.theme.primaryLight,
        height: 81,
        transform: 'translate(-50%, 15px)',
        [styling.breakpoints.up('md')]: {
          height: 130,
          transform: 'translate(-50%, 15px)',
        },
      },
    },
  },
  { name: 'homeMissionSelect' },
);
